/* global __VXAPP_BUILD_INFO__:readonly */

export interface AppBuildInfo {
  readonly version: string
  readonly buildNumber: string
  readonly commitSha: string
  readonly builtAt: string
  readonly environment: string
}

const rawBuildInfo =
  typeof __VXAPP_BUILD_INFO__ === 'undefined' ? ({} as Partial<AppBuildInfo>) : __VXAPP_BUILD_INFO__

const normalizeValue = (value: unknown, fallback = ''): string => {
  if (typeof value !== 'string') {
    return fallback
  }

  const normalizedValue = value.trim()

  if (!normalizedValue || normalizedValue.toLowerCase() === 'unknown') {
    return fallback
  }

  return normalizedValue
}

const normalizeDisplayVersion = (version: string): string => {
  if (/^\d+\.\d+$/.test(version)) {
    return `${version}.0`
  }

  return version
}

export const APP_BUILD_INFO: AppBuildInfo = Object.freeze({
  version: normalizeDisplayVersion(normalizeValue(rawBuildInfo.version, '0.0.0')),
  buildNumber: normalizeValue(rawBuildInfo.buildNumber),
  commitSha: normalizeValue(rawBuildInfo.commitSha),
  builtAt: normalizeValue(rawBuildInfo.builtAt),
  environment: normalizeValue(rawBuildInfo.environment),
})

export const APP_BUILD_IDENTIFIER = APP_BUILD_INFO.buildNumber || APP_BUILD_INFO.commitSha

export const APP_BUILD_BADGE_TEXT = APP_BUILD_IDENTIFIER
  ? `v${APP_BUILD_INFO.version} build ${APP_BUILD_IDENTIFIER}`
  : `v${APP_BUILD_INFO.version}`

export const APP_BUILD_TITLE = [
  `Version ${APP_BUILD_INFO.version}`,
  APP_BUILD_INFO.buildNumber ? `Build ${APP_BUILD_INFO.buildNumber}` : '',
  APP_BUILD_INFO.commitSha ? `Commit ${APP_BUILD_INFO.commitSha}` : '',
  APP_BUILD_INFO.builtAt ? `Built ${APP_BUILD_INFO.builtAt}` : '',
  APP_BUILD_INFO.environment ? `Environment ${APP_BUILD_INFO.environment}` : '',
]
  .filter(Boolean)
  .join(' | ')
